import { render, staticRenderFns } from "./EditFodderModal.vue?vue&type=template&id=6254b7ca&scoped=true&lang=pug&"
import script from "./EditFodderModal.vue?vue&type=script&lang=js&"
export * from "./EditFodderModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFodderModal.vue?vue&type=style&index=0&id=6254b7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254b7ca",
  null
  
)

export default component.exports